import { render, staticRenderFns } from "./AppFeatureWrapper.global.vue?vue&type=template&id=41bcf93b&functional=true&"
import script from "./AppFeatureWrapper.global.vue?vue&type=script&lang=js&"
export * from "./AppFeatureWrapper.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports